import React from 'react';
// import Chart from 'chart.js/auto';
import PropTypes from "prop-types";
import './PtpOverlay.scss';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const PtpOverlay = ({ data }) => {

    const data2 = [
        { name: 'Group A', value: 400 },
        { name: 'Group B', value: 300 },
    ];
    const COLORS = ['#83ABED', '#F1F4F9', '#FFBB28', '#FF8042'];
    // console.log("ptp drilldown data ============>",data)

    const arrStatus = data?.arrStatus;
    const ptpStats = data?.ptpStats;

    const totalAccountsCount = arrStatus?.reduce((total, item) => total + item.accountsCount, 0);
    const totalAmount = arrStatus?.reduce((total, item) => total + item.amount, 0);

    const ptpAccountsCount = ptpStats?.reduce((total, item) => total + item.accountsCount, 0);
    const ptpAmount = ptpStats?.reduce((total, item) => total + item.amount, 0);

    // const calculatePercentages = (data) => {
    //     const totalAccountsCount = data?.reduce((total, item) => total + item.accountsCount, 0);
    //     const totalAmount = data?.reduce((total, item) => total + item.amount, 0);

    //     const brokenCount = data?.find(item => item.arrStatus === 'BROKEN' || item.ptpStatus === 'BROKEN').accountsCount;
    //     const keptCount = data?.find(item => item.arrStatus === 'KEPT' || item.ptpStatus === 'KEPT').accountsCount;
    //     const partiallyKeptCount = data?.find(item => item.arrStatus === 'PARTIALLY_KEPT' || item.ptpStatus === 'PARTIALLY_KEPT').accountsCount;

    //     const brokenPercentage = (brokenCount / totalAccountsCount) * 100;
    //     const keptPercentage = ((keptCount + partiallyKeptCount) / totalAccountsCount) * 100;

    //     return { brokenPercentage, keptPercentage, totalAmount };
    // };

    // const calculatePercentages = (data) => {
    //     const totalAccountsCount = data?.reduce((total, item) => total + item.accountsCount, 0);
    //     const totalAmount = data?.reduce((total, item) => total + item.amount, 0);

    //     const brokenItem = data?.find(item => item.arrStatus === 'BROKEN' || item.ptpStatus === 'BROKEN');
    //     const keptItem = data?.find(item => item.arrStatus === 'KEPT' || item.ptpStatus === 'KEPT');

    //     const brokenCount = brokenItem?.accountsCount || 0;
    //     const keptCount = (keptItem?.accountsCount || 0) + (data?.find(item => item.arrStatus === 'PARTIALLY_KEPT' || item.ptpStatus === 'PARTIALLY_KEPT')?.accountsCount || 0);

    //     const brokenPercentage = (brokenCount / totalAccountsCount) * 100;
    //     const keptPercentage = (keptCount / totalAccountsCount) * 100;

    //     return { brokenPercentage, keptPercentage, totalAmount };
    // };
    const calculatePercentages = (data) => {
        const totalAccountsCount = data?.reduce((total, item) => total + item.accountsCount, 0);
        const totalAmount = data?.reduce((total, item) => total + item.amount, 0);

        const brokenItem = data?.find(item => item.arrStatus === 'BROKEN' || item.ptpStatus === 'BROKEN');
        const keptItem = data?.find(item => item.arrStatus === 'KEPT' || item.ptpStatus === 'KEPT');

        console.log("brokenItem:", brokenItem);
        console.log("keptItem:", keptItem);

        const brokenCount = brokenItem?.accountsCount || 0;
        const keptCount = (keptItem?.accountsCount || 0) + (data?.find(item => item.arrStatus === 'PARTIALLY_KEPT' || item.ptpStatus === 'PARTIALLY_KEPT')?.accountsCount || 0);

        console.log("brokenCount:", brokenCount);
        console.log("keptCount:", keptCount);

        const brokenPercentage = (brokenCount / totalAccountsCount) * 100;
        const keptPercentage = (keptCount / totalAccountsCount) * 100;

        console.log("brokenPercentage:", brokenPercentage);
        console.log("keptPercentage:", keptPercentage);

        return { brokenPercentage, keptPercentage, totalAmount };
    };


    const arrStatusPercentages = calculatePercentages(data?.arrStatus)
    const ptpStatsPercentages = calculatePercentages(data?.ptpStats)

    console.log("arr percentage ptp percentage ========>", arrStatusPercentages, ptpStatsPercentages);
    console.log(isNaN(arrStatusPercentages.keptPercentage));

    // const arrPieSlice = [
    //     {name:"KEPT",value:arrStatusPercentages.keptPercentage},
    //     {name:"BROKEN",value:arrStatusPercentages.brokenPercentage}
    // ]

    // const ptpPieSlice = [
    //     {name:"KEPT",value:ptpStatsPercentages.keptPercentage},
    //     {name:"BROKEN",value:ptpStatsPercentages.brokenPercentage},
    // ]

    const arrPieSlice = [
        { name: "KEPT", value: isNaN(arrStatusPercentages.keptPercentage) ? 0 : arrStatusPercentages.keptPercentage },
        { name: "BROKEN", value: isNaN(arrStatusPercentages.brokenPercentage) ? 0 : arrStatusPercentages.brokenPercentage }
    ];

    const ptpPieSlice = [
        { name: "KEPT", value: isNaN(ptpStatsPercentages.keptPercentage) ? 0 : ptpStatsPercentages.keptPercentage },
        { name: "BROKEN", value: isNaN(ptpStatsPercentages.brokenPercentage) ? 0 : ptpStatsPercentages.brokenPercentage },
    ];


    console.log('arrStatus Percentages:', arrPieSlice);
    console.log('ptpStats Percentages:', ptpPieSlice);

    return (
        <>
            <div className="card" id='overlay-ptp'>
                <div className="card-header" id='amount-modal-header'>
                    <h3>Promises</h3>
                </div>
                <div className="card-body" id='ptp-modal'>
                    <div className='half-donut-ptp'>
                        <div className='half-donut-ptp__header'>
                            <h3>Arrangements</h3>
                        </div>
                        <div className='half-donut-ptp__pie'>
                            <ResponsiveContainer width={300} height={300}>
                                <PieChart>
                                    <Pie
                                        data={arrPieSlice}
                                        cx="50%"
                                        cy="40%"
                                        innerRadius={60}
                                        outerRadius={80}
                                        fill="#82ca9d"
                                        startAngle={180}
                                        endAngle={0}
                                        paddingAngle={5}
                                        dataKey="value"
                                    >
                                        {data2.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>

                        <div id='arr_per'>
                            {/* <p>KEPT - {arrStatusPercentages.keptPercentage.toFixed(2)+"%"}</p> */}
                            <p>KEPT - {isNaN(arrStatusPercentages.keptPercentage) ? 0 + "%" : arrStatusPercentages.keptPercentage.toFixed(2) + "%"}</p>
                            <p>BROKEN - {isNaN(arrStatusPercentages.brokenPercentage) ? 0 + "%" : arrStatusPercentages.brokenPercentage.toFixed(2) + "%"}</p>
                        </div>

                        <div className='arr-modal-tables'>

                            <div id='arr-count'>
                                {arrStatus?.map((item, index) => (
                                    <div className='ptp-table' key={index}>
                                        <p>{item.arrStatus}</p>
                                        <p>{item.accountsCount}</p>
                                    </div>
                                ))}
                                <div className='arr-table'>
                                    <p>Total Arrangement</p>
                                    <p>{totalAccountsCount}</p>
                                </div>
                            </div>
                            <div id='arr-amount'>

                                {arrStatus?.map((item, index) => (
                                    <div className='arr-table' key={index}>
                                        <p>{item.arrStatus}</p>
                                        <p>{item.amount}</p>
                                    </div>
                                ))}
                                <div className='arr-table'>
                                    <p>Total Arrangement Amount</p>
                                    <p>{totalAmount}</p>
                                </div>
                            </div>
                        </div>

                        <div className='ptp-modal-tables'>
                            <div id='ptp-count'>
                                {ptpStats?.map((item, index) => (
                                    <div className='ptp-table' key={index}>
                                        <p>{item.ptpStatus}</p>
                                        <p>{item.accountsCount}</p>
                                    </div>
                                ))}
                                <div className='ptp-table'>
                                    <p>Total Arrangement</p>
                                    <p>{ptpAccountsCount}</p>
                                </div>
                            </div>
                            <div id='ptp-amount'>

                                {ptpStats?.map((item, index) => (
                                    <div className='ptp-table' key={index}>
                                        <p>{item.ptpStatus}</p>
                                        <p>{item.amount}</p>
                                    </div>
                                ))}

                                <div className='ptp-table'>
                                    <p>Total Arrangement Amount</p>
                                    <p>{ptpAmount}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='half-donut-arrangements'>
                        <div className='half-donut-arrangements__header'>
                            <h3>PTP</h3>
                        </div>
                        <div className='half-donut-arrangements__pie'>
                            <ResponsiveContainer width={300} height={300}>
                                <PieChart>
                                    <Pie
                                        data={ptpPieSlice}
                                        cx="50%"
                                        cy="27%"
                                        innerRadius={60}
                                        outerRadius={80}
                                        fill="#82ca9d"
                                        startAngle={180}
                                        endAngle={0}
                                        paddingAngle={5}
                                        dataKey="value"
                                    >
                                        {data2.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>

                        <div id='ptp_per'>
                            {/* <p>KEPT - {ptpStatsPercentages.keptPercentage.toFixed(2)+"%"}</p> */}
                            <p>KEPT - {isNaN(ptpStatsPercentages.keptPercentage) ? 0 + "%" : ptpStatsPercentages.keptPercentage.toFixed(2) + "%"}</p>
                            <p>BROKEN - {isNaN(ptpStatsPercentages.brokenPercentage) ? 0 + "%" : ptpStatsPercentages.brokenPercentage.toFixed(2) + "%"}</p>
                        </div>

                    </div>
                </div>

            </div>
        </>
    );
};

PtpOverlay.propTypes = {
    number: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
    })).isRequired,
};

export default PtpOverlay;